import nls from '../es/EnterAmount.js';
export default {
  ...nls,
  'You have available credit up to': 'Tiene disponible hasta',
  'Capture the amount you want': 'Capture el monto que desea',
  'The amount you entered must be greater than $': 'El monto que ingresó debe ser mayor a $',
  'Amount exceeds available credit limit': 'El monto que ingreso excede el límite de crédito disponible',
  'The amount of your payments will change according to the amount of credit you captured': 'El importe de sus pagos cambiara de acuerdo al monto de crédito que capturó',
  'Please correct the following:': 'Por favor, corrija lo siguiente:',
};
